export const filterActiveEmployees = (employees) => {
    if (!employees) return [];
    return employees.filter((emp) => emp.isActive !== false);
};
